import { ReactNode } from 'react';

interface CatalogSetupStateProps {
  action?: ReactNode;
  hasCompany: boolean;
  hasDeliveryAddresses: boolean;
}

export function CatalogSetupState({
  action,
  hasCompany,
  hasDeliveryAddresses,
}: CatalogSetupStateProps) {
  const title = getTitle(hasCompany, hasDeliveryAddresses);
  const description = getDescription(hasCompany, hasDeliveryAddresses);

  return (
    <section className="catalog-setup-state" aria-label="Подготовка витрины">
      <div className="catalog-setup-state__icon" aria-hidden="true">
        <svg viewBox="0 0 24 24">
          <path d="M4 10.5V20h16v-9.5" />
          <path d="M3 4h18l-1.5 6a3 3 0 0 1-5.5 1.1A3 3 0 0 1 8.5 10 3 3 0 0 1 3 10Z" />
          <path d="M9 20v-5h6v5" />
        </svg>
      </div>
      <div className="catalog-setup-state__content">
        <p className="admin-eyebrow">Подготовка витрины</p>
        <h2>{title}</h2>
        <p>{description}</p>
        <ol className="catalog-setup-state__steps">
          <li className={hasCompany ? 'is-complete' : 'is-active'}>
            <span>{hasCompany ? '✓' : '1'}</span>
            <div>
              <strong>Выберите компанию</strong>
              <small>Определим доступные точки доставки.</small>
            </div>
          </li>
          <li className={hasCompany ? 'is-active' : ''}>
            <span>2</span>
            <div>
              <strong>Выберите точку доставки</strong>
              <small>Рассчитаем ассортимент, цены и сроки.</small>
            </div>
          </li>
        </ol>
        {action ? <div className="catalog-setup-state__action">{action}</div> : null}
      </div>
    </section>
  );
}

function getTitle(hasCompany: boolean, hasDeliveryAddresses: boolean): string {
  if (!hasCompany) {
    return 'Начните с выбора компании';
  }

  if (!hasDeliveryAddresses) {
    return 'У компании пока нет точек доставки';
  }

  return 'Теперь выберите точку доставки';
}

function getDescription(hasCompany: boolean, hasDeliveryAddresses: boolean): string {
  if (!hasCompany) {
    return 'Выберите компанию ниже — после этого станут доступны ее адреса доставки.';
  }

  if (!hasDeliveryAddresses) {
    return 'Добавьте адрес в карточке компании, чтобы увидеть доступные товары и условия поставщиков.';
  }

  return 'По адресу мы определим зоны обслуживания и покажем актуальные предложения поставщиков.';
}
